/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
/* eslint max-len: 0 */
import * as Blockly from 'blockly';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';

// setOutput(true, Number) usa el constructor a propósito: calza con el check de
// math_number. Solo Boolean va como string en v13.

// Pin en el campo PIN (no NPIN) y combo analog sin clave de componente, como el legacy.
Blockly.Blocks.inout_analog_read = {
  init: function () {
    this.setColour(colors.COLOUR_ENTRADAS);
    this.setOutputShape(options.SHAPES.ROUND);
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_ADVANCED_INOUT_ANALOG_READ)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('analog'),
      ), 'PIN');
    this.setInputsInline(true);
    this.setOutput(true, Number);
    this.setTooltip(Blockly.Msg.LANG_ADVANCED_INOUT_ANALOG_READ_TOOLTIP);
  },
};

Blockly.Blocks.entradas_lluvia = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/50.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_LLUVIA)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('analog', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setOutput(true, Number);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_LLUVIA_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'rain',
};

Blockly.Blocks.entradas_sonido = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/01.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_SONIDO)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('analog', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setOutput(true, Number);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_SONIDO_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'sound',
};

// Bug del legacy preservado: usa el component de entradas_sonido ('sound'), así
// los pines de gas y sonido comparten pool.
Blockly.Blocks.entradas_gas = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/gas.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_GAS_READ)
      .appendField(Blockly.Msg.LANG_PIN)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('analog', 'sound_NPIN'),
      ), 'NPIN');
    this.setOutput(true, Number);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_SONIDO_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'sound',
};

Blockly.Blocks.entradas_suelo = {
  init: function () {
    this.setOutputShape(options.SHAPES.ROUND);
    this.setColour(colors.COLOUR_ENTRADAS);
    this.appendDummyInput('')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/educablocks/05.svg`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA)
      .appendField(Blockly.Msg.LANG_ENTRADAS_SUELO)
      .appendField(new Blockly.FieldDropdown(
        () => Blockly.getMainWorkspace().getHardwarePinsCombo('analog', `${this.component}_NPIN`),
      ), 'NPIN');
    this.setOutput(true, Number);
    this.setTooltip(Blockly.Msg.LANG_ENTRADAS_SUELO_TOOLTIP);
  },
  getPins: function () { return ['NPIN']; },
  component: 'soil',
};
